module.exports = __webpack_public_path__ + "static/CRS_07_new-3997649bfd3486134a4f06a988acb55c.svg";